import Vue from 'vue'
import Router from 'vue-router'
// 登录模块
import login from '@/page/login'
// 首页模块
import Home from '@/page/Home'
import mapIndex from '../page/Home/mapIndex' //地图大屏展示

//个人信息
import userInfo from '@/page/userInfo'
//顶部、左侧公共模块
import Content from '../page/Content/content.vue'

//监管端首页地图
import mapIndexHome from '../page/mapIndexHome'

//刷新页面
import refresh from '../components/reload/refresh.vue'

// 监控中心--校企业端
import Monitoring from '@/page/Monitoring' //监控中心首页
import monitorDetails from '@/page/Monitoring/monitorDetails' //监控详情

// 监控中心--监管端
import MonitoringSupervise from '@/page/MonitoringSupervise' //监控中心首页
// import MonitorSuperviseDetails from '@/page/MonitoringSupervise/MonitorSuperviseDetails' //监控详情.

//报警管理
import warningManger from '../page/warningManger' //报警详情
import indexExamine from '../page/warningManger/indexExamine' //报警审核
import editForm from '../page/warningManger/editForm' //编辑报警详情
import warnDetail from '../page/warningManger/warnDetail' //报警详情
import warnExamine from '../page/warningManger/warnExamine' //报警审核
import searchForm from '../page/warningManger/searchForm' //查看报警详情
import examineSuccess from '../page/warningManger/examineSuccess' //审核成功
import exitSuccess from '../page/warningManger/exitSuccess' //退回成功
import saveSuccess from '../page/warningManger/saveSuccess' //保存成功
import withDrawSuccess from '../page/warningManger/withDrawSuccess' //撤回成功
import deleteSuccess from '../page/warningManger/deleteSuccess' //删除成功
import submitSuccess from '../page/warningManger/submitSuccess' //提交审核成功
import searchWarnIndex from '../page/warningManger/searchWarnIndex' //综合查询
import searchWarnDetail from '../page/warningManger/searchWarnDetail' //综合查询详情

// 统计分析模块
import analysis from '@/page/analysis'
import report from '@/page/analysis/report'
import deviceList from '@/page/analysis/deviceList'

// 校企标注模块
import superviseTagging from '@/page/superviseTagging'

//基础数据管理
import BasicData from '@/page/BasicData' //监测点管理
import addMonitor from '@/page/BasicData/addMonitor' //创建监测点
import addView from '@/page/BasicData/addView' //创建3D可配置选项设备
import addViewX from '@/page/addViewX' //创建3D可配置选项视角


import saveSuccessfully from '@/page/BasicData/saveSuccessfully' //监测点信息保存成功
import saveSuccessfully1 from '@/page/BasicData/saveSuccessfully1' //新建建筑点
import delSuccessfully1 from '@/page/BasicData/delSuccessfully1' //新建建筑点
import deleteSuccessfully from '@/page/BasicData/deleteSuccessfully' //监测点信息删除成功
import Construction from '@/page/BasicData/Construction' //建筑管理
import EditBuliting from '../page/editBuliting/editBuliting.vue' //建筑管理->编辑建筑信息
import constructionManagement from '../components/constructionManagement/constructionManagement'


// 系统管理
import roleManger from '../page/systemManger/roleManger.vue' // 角色管理
import userManger from '../page/systemManger/userManger.vue' // 用户管理
import permissions from '../page/systemManger/permissions.vue' // 权限管理
import parameterManger from '../page/systemManger/parameterManger.vue' // 参数管理
import journal from '../page/systemManger/journal.vue' // 日志
import editorialRole from '../page/systemManger/editorialRole.vue' // 角色管理->编辑角色
import editUser from '../page/systemManger/editUser.vue' // 用户管理->编辑用户
import saveUserInfoSuccess from '../page/systemManger/saveSuccess' //用户管理保存成功
import searchUserInfo from '../page/systemManger/searchUserInfo' //用户管理查看用户信息
import roleSaveSuccess from '../page/systemManger/roleSaveSuccess' //角色管理保存成功
import permissionManger from '../page/systemManger/permissionManger' //权限管理列表
import tipspage from '@/page/tipspage' //无权限页面
//通知公告
import notificate from '../page/notificate' //通知公告
import editNotificate from '../page/notificate/editNotificate' //编辑公告
// 国际化
import lang from '@/page/lang'

Vue.use(Router);

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    // mode: 'history',
    routes: [{
            path: '/',
            name: '登录',
            component: login,
            meta: {
                title: '登录'
            },
        },
        {
            path: '/Home',
            name: '首页',
            component: Home,
            meta: {
                title: '首页'
            },
        },
        {
            path: '/mapIndex',
            name: '地图大屏',
            component: mapIndex,
            meta: {
                title: '地图大屏'
            },
        },
        {
            path: '/mapIndexHome',
            name: '监管端地图首页',
            component: mapIndexHome,
            meta: {
                title: '地图首页'
            },
        },
        {
            path: '/refresh',
            name: '空白',
            component: refresh,
            meta: {
                title: '空白'
            },
        },
        {
            path: '/lang',
            name: '国际化',
            component: lang,
            meta: {
                title: '中英文'
            },
        },
        {
            path: '/permissionManger',
            name: '权限管理-首页',
            component: permissionManger,
            meta: {
                title: '权限管理-首页'
            },
        },
        {
            path: '/notificate',
            name: '通知公告-首页',
            component: notificate,
            meta: {
                title: '通知公告'
            },
        },
        {
            path: '/editNotificate',
            name: '编辑公告',
            component: editNotificate,
            meta: {
                title: '编辑公告'
            },
        },
        {
            path: '/tipspage',
            name: '无权限',
            component: tipspage,
            meta: {
                title: '无权限'
            },
        },
        {
            path: '/Construction',
            component: Construction,
            name: '建筑管理',
            meta: {
                roles: '建筑管理'
            }
        },
        {
            path: '/roleManger',
            name: '角色管理',
            component: roleManger,
            meta: {
                title: '角色管理'
            },
        }, {
            path: '/roleSaveSuccess',
            name: '角色管理-保存成功',
            component: roleSaveSuccess,
            meta: {
                title: '角色管理-保存成功'
            },
        },
        {
            path: '/saveUserInfoSuccess',
            name: '用户管理-保存成功',
            component: saveUserInfoSuccess,
            meta: {
                title: '用户管理-保存成功'
            },
        },
        {
            path: '/searchUserInfo',
            name: '用户管理-查看',
            component: searchUserInfo,
            meta: {
                title: '用户管理-查看'
            },
        },
        {
            path: '/editorialRole',
            name: '编辑角色',
            component: editorialRole,
            meta: {
                title: '编辑角色'
            },
        },
        {
            path: '/userInfo',
            component: userInfo,
            name: '个人信息',
            meta: {
                title: '个人信息'
            },
        },
        {
            path: '/userManger',
            name: '用户管理',
            component: userManger,
            meta: {
                title: '用户管理'
            },
        },
        {
            path: '/editUser',
            name: '编辑用户',
            component: editUser,
            meta: {
                title: '编辑用户'
            },
        },
        {
            path: '/permissions',
            name: '权限管理',
            component: permissions,
            meta: {
                title: '权限管理'
            },
        },
        {
            path: '/parameterManger',
            name: '参数管理',
            component: parameterManger,
            meta: {
                title: '参数管理'
            },
        },
        {
            path: '/journal',
            name: '日志',
            component: journal,
            meta: {
                title: '日志'
            },
        },
        {
            path: '/addViewX',
            component: addViewX,
            name: '3D配置项视角',
            meta: {
                title: '3D配置项视角'
            },
        },

        {
            path: '/content',
            name: '主页',
            component: Content,
            meta: {
                title: '主页'
            },
            children: [{
                    path: 'Monitoring',
                    name: '监控中心',
                    component: Monitoring,
                    meta: {
                        title: '监控中心'
                    },
                },
                {
                    path: 'MonitoringSupervise',
                    name: '监控中心',
                    component: MonitoringSupervise,
                    meta: {
                        title: '监控中心'
                    },
                },
                {
                    path: 'monitorDetails',
                    name: '监控详情',
                    component: monitorDetails,
                    meta: {
                        title: '监控详情'
                    },
                },
                {
                    path: 'analysis',
                    name: '统计分析',
                    component: analysis,
                    meta: {
                        title: '统计分析'
                    },
                },
                {
                    path: 'report',
                    component: report,
                    name: '分析报告',
                    meta: {
                        title: '分析报告'
                    },
                },
                {
                    path: 'deviceList',
                    component: deviceList,
                    name: '设备列表',
                    meta: {
                        title: '设备列表'
                    },
                },
                {
                    path: 'superviseTagging',
                    name: '校企标注',
                    component: superviseTagging,
                    meta: {
                        title: '校企标注'
                    },
                },
                {
                    path: 'BasicData',
                    component: BasicData,
                    name: '监测点管理',
                    meta: {
                        title: '监测点管理'
                    },
                },
                {
                    path: 'addMonitor',
                    component: addMonitor,
                    name: '创建监测点',
                    meta: {
                        title: '创建监测点'
                    },
                },
                {
                    path: 'addView',
                    component: addView,
                    name: '3D配置项',
                    meta: {
                        title: '3D配置项'
                    },
                },


                {
                    path: 'saveSuccessfully',
                    component: saveSuccessfully,
                    name: '保存成功',
                    meta: {
                        title: '保存成功'
                    },
                },
                {
                    path: 'saveSuccessfully1',
                    component: saveSuccessfully1,
                    name: '保存成功1',
                    meta: {
                        title: '保存成功'
                    },
                },
                {
                    path: 'delSuccessfully1',
                    component: delSuccessfully1,
                    name: '删除成功1',
                    meta: {
                        title: '删除成功'
                    },
                },
                {
                    path: 'deleteSuccessfully',
                    component: deleteSuccessfully,
                    name: '删除成功',
                    meta: {
                        title: '删除成功'
                    },
                },
                {
                    path: 'constructionManagement',
                    component: constructionManagement,
                    name: '楼层管理',
                    meta: {
                        title: '楼层管理'
                    },
                },
                {
                    path: 'editBuliting',
                    component: EditBuliting,
                    name: '编辑建筑信息',
                },
                {
                    path: 'warningManger',
                    component: warningManger,
                    name: '报警处理',
                    meta: {
                        title: '报警处理'
                    },
                }, {
                    path: 'indexExamine',
                    component: indexExamine,
                    name: '报警审核',
                    meta: {
                        title: '报警审核'
                    },
                }, {
                    path: 'editForm',
                    component: editForm,
                    name: '编辑详情',
                    meta: {
                        title: '编辑详情'
                    },
                },
                {
                    path: 'warnDetail',
                    component: warnDetail,
                    name: '报警详情',
                    meta: {
                        title: '报警详情'
                    },
                },
                {
                    path: 'warnExamine',
                    component: warnExamine,
                    name: '审核详情',
                    meta: {
                        title: '审核详情'
                    },
                },
                {
                    path: 'searchForm',
                    component: searchForm,
                    name: '查看告警处理详情',
                    meta: {
                        title: '查看告警处理详情'
                    },
                },
                {
                    path: 'examineSuccess',
                    component: examineSuccess,
                    name: '审核成功',
                    meta: {
                        title: '审核成功'
                    },
                }, {
                    path: 'submitSuccess',
                    component: submitSuccess,
                    name: '提交审核成功',
                    meta: {
                        title: '提交审核成功'
                    },
                },
                {
                    path: 'exitSuccess',
                    component: exitSuccess,
                    name: '退出成功',
                    meta: {
                        title: '退出成功'
                    },
                }, {
                    path: 'deleteSuccess',
                    component: deleteSuccess,
                    name: '报警详情-删除成功',
                    meta: {
                        title: '删除成功'
                    },
                }, {
                    path: 'withDrawSuccess',
                    component: withDrawSuccess,
                    name: '撤回成功',
                    meta: {
                        title: '撤回成功'
                    },
                }, {
                    path: 'saveSuccess',
                    component: saveSuccess,
                    name: '报警详情-保存成功',
                    meta: {
                        title: '保存成功'
                    },
                },
                {
                    path: 'searchWarnIndex',
                    component: searchWarnIndex,
                    name: '综合查询',
                    meta: {
                        title: '综合查询'
                    },
                }, {
                    path: 'searchWarnDetail',
                    component: searchWarnDetail,
                    name: '综合查询-报警详情',
                    meta: {
                        title: '综合查询-报警详情'
                    },
                },
            ]
        },

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js